import * as React from "react"
import {CardSeeker} from "@ui-seeker/core";
import {Box, Typography} from "@mui/material";
import {formatNumber, formatPercentage} from "@ui-seeker/utils";

import {useUserApp} from "@hooks";
import PriceEvolutionWidgetIcon from "./Icon";
import PriceEvolutionWidgetTooltip from "./Tooltip";



const _calculateDiff = (customDiff=null, current, previous, isPercentage) => {
	if (customDiff)
		return customDiff
	if (current ===  previous || !current || !previous)
		return isPercentage ? formatNumber(0, { decimals: 1, suffix: 'p.p.' }) : formatPercentage(0)
	if (isPercentage)
		return formatNumber(current - previous, { decimals: 1, suffix: 'p.p.' })
	return formatPercentage(((current - previous) / previous) * 100)
}

export default function PriceEvolutionBaseWidget(props) {
	const {
		title, sx={},
		currentValue, current, prevValue, previous, customDiff='', isPercentage, reverse=false,
		maxValue=null, maxDates=[], minValue=null, minDates=[], labelTooltipMin, labelTooltipMax, fontTooltip, higherMax, lowerMin,
		numVariants= null
	} = props
	const { userGroupByProductID } = useUserApp()
	const positiveColor = reverse ? "error" : "success"
	const negativeColor = reverse ? "success" : "error"
	let isNeutral = currentValue === prevValue
	const diff = _calculateDiff(customDiff, currentValue, prevValue, isPercentage)
	const diffNumber = !customDiff && parseInt(diff.replace('%', '').replace('p.p.', ''))
	if (diffNumber === 0 && !isNeutral)
		isNeutral = true

	return <CardSeeker
		title={title}
		elevation={0}
		sx={{
			border: "2px solid",
			borderColor: 'primary.light',
			...sx
		}}
		headerProps={{
			sx: { p: 2, pb: 0, fontsize: "1.15rem" }
		}}
		contentProps={{
			sx: { mx: -1, py: 1, pb: "8px !important" }
		}}
	>
		<Box display="flex" justifyContent="space-between" pb={1}>
			<Typography variant="h6">
				{current}
			</Typography>

			{ maxValue !== null && <PriceEvolutionWidgetTooltip
				data={maxDates}
				label={labelTooltipMax}
				value={maxValue}
				fontSize={fontTooltip}
				showIcon={higherMax}
				isPercentage={isPercentage}
				color="error.main"
			/> }
		</Box>

		<Box display="flex" justifyContent="space-between">
			<Typography variant="subtitle2" component="div" noWrap display="flex" alignItems="center" fontSize="0.75rem">
				{ !!previous && <Box sx={{ color: 'text.secondary', pr: 1 }}>
					{previous}
				</Box> }

				{ isNeutral ? <PriceEvolutionWidgetIcon
					icon="eva:minus-circle-fill"
					color="text.disabled"
					backgroundColor="grey.300"
				/> : <PriceEvolutionWidgetIcon
					icon={diffNumber > 0 ? "eva:trending-up-fill" : "eva:trending-down-fill"}
					color={diffNumber > 0 ? `${positiveColor}.darker` : `${negativeColor}.main`}
					backgroundColor={diffNumber > 0 ? `${positiveColor}.lighter` : `${negativeColor}.lighter`}
				/>}
				<Box>{previous === 'N/A' ? '-' : diff}</Box>
			</Typography>

			{ minValue !== null && <PriceEvolutionWidgetTooltip
				data={minDates}
				label={labelTooltipMin}
				value={minValue}
				fontSize={fontTooltip}
				showIcon={lowerMin}
				isPercentage={isPercentage}
				color="success.main"
			/> }
		</Box>

		{!userGroupByProductID && <Box>
			<Typography variant="subtitle2" fontSize="0.75rem">Num Variants : {numVariants} </Typography>
		</Box>}
	</CardSeeker>
}